module.exports = __webpack_public_path__ + "img/image2.887550c.webp";